import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Loading from '~/components/views/common/Loading/Loading';
import RetryButton from '~/components/views/retry/RetryButton/RetryButton';
import formatMessageWrapper from '~/utils/format-message-wrapper/format-message-wrapper';
import { InternationalizationNameSpace } from '~/constants/internationalization-namespace';

const WebViewReload = () => {
  useTranslation([InternationalizationNameSpace.Legacy]);
  const [showRetryButton, setShowRetryButton] = useState(false);

  const onRetryClick = useCallback(() => {
    window.location.reload();
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => setShowRetryButton(true), 3000);
    return () => clearTimeout(timer);
  }, []);
  return showRetryButton ? (
    <RetryButton
      callback={onRetryClick}
      errorMessage={formatMessageWrapper('web.error.something_went_wrong')}
    />
  ) : (
    <Loading />
  );
};

export default WebViewReload;
